<form
  class="form"
  id="dataUpdateForm"
  [ngClass]="{ 'Confirm-data': confirmData }"
  [formGroup]="formGroup"
>
  <div class="mt-5 title" *ngIf="confirmData">
    <span [innerHTML]="copyService.copies.client_data_update.title"></span>
  </div>
  <div class="mt-2 subtitle" *ngIf="confirmData">
    <span [innerHTML]="copyService.copies.client_data_update.subtitle"></span>
  </div>
  <vcl-alert
    *ngIf="confirmData"
    class="mt-3"
    [type]="'success'"
    [icon]="'check'"
    [dismissible]="true"
  >
    {{ copyService.copies.client_data_confirm.modal_content }}
  </vcl-alert>
  <!-- Personal -->
  <div *ngIf="personalData">
    <div class="mt-5 title_card">
      <span
        [innerHTML]="copyService.copies.client_data_update.personal.title"
      ></span>
    </div>
    <div class="info-section">
      <voxel-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        [label]="copyService.copies.client_data_update.personal.district.label"
        [msgErr]="copyService.copies.client_data_update.personal.district.error"
      >
        <vcl-autocomplete
          [placeholder]="
            copyService.copies.client_data_update.personal.district
              .filter_placeholder
          "
          [notFoundTitle]="
            copyService.copies.client_data_update.personal.district
              .filter_not_found_title
          "
          [notFoundMessage]="
            copyService.copies.client_data_update.personal.district
              .filter_not_found_message
          "
          formControlName="districtValue"
          (change)="districtSelect($event, 'personal')"
        >
          <vcl-option
            [selected]="
              selectedCityResidence.description
                .toUpperCase()
                .indexOf(
                  districtOption.district
                    .toUpperCase()
                    .replace('Á', 'A')
                    .replace('É', 'E')
                    .replace('Í', 'I')
                    .replace('Ó', 'O')
                    .replace('Ú', 'U')
                ) > -1
            "
            *ngFor="let districtOption of district_option"
            [value]="districtOption"
          >
            {{ districtOption.district }}
          </vcl-option>
        </vcl-autocomplete>
      </voxel-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.personal.district.label
        }}</label>
        <p>{{ formControls.districtValue.value.district }}</p>
      </div>
      <voxel-form-field
        *ngIf="!isDisabledCity; else isDisabledCityForm"
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        id="cityResidenceLabel"
        [label]="copyService.copies.client_data_update.personal.city.label"
        [msgErr]="copyService.copies.client_data_update.personal.city.error"
      >
        <vcl-autocomplete
          id="cityResidence"
          [placeholder]="
            copyService.copies.client_data_update.personal.city
              .filter_placeholder
          "
          formControlName="cityResidence"
          [notFoundTitle]="
            copyService.copies.client_data_update.personal.city
              .filter_not_found_title
          "
          [notFoundMessage]="
            copyService.copies.client_data_update.personal.city
              .filter_not_found_message
          "
        >
          <vcl-option
            [id]="'cityResidence' + cityOption.id"
            *ngFor="let cityOption of city_option"
            [selected]="
              selectedCityResidence.description
                .toUpperCase()
                .indexOf(
                  cityOption.city
                    .toUpperCase()
                    .replace('Á', 'A')
                    .replace('É', 'E')
                    .replace('Í', 'I')
                    .replace('Ó', 'O')
                    .replace('Ú', 'U')
                ) > -1
            "
            [value]="cityOption"
          >
            {{ cityOption.city }}
          </vcl-option>
        </vcl-autocomplete>
      </voxel-form-field>
      <ng-template #isDisabledCityForm>
        <voxel-form-field
          class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
          id="cityResidenceLabel"
          [label]="copyService.copies.client_data_update.personal.city.label"
          [msgErr]="copyService.copies.client_data_update.personal.city.error"
        >
          <vcl-autocomplete
            [placeholder]="
              copyService.copies.client_data_update.personal.city
                .filter_placeholder
            "
            [notFoundTitle]="
              copyService.copies.client_data_update.personal.city
                .filter_not_found_title
            "
            [notFoundMessage]="
              copyService.copies.client_data_update.personal.city
                .filter_not_found_message
            "
          >
          </vcl-autocomplete>
        </voxel-form-field>
      </ng-template>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.personal.city.label
        }}</label>
        <p>{{ formControls.cityResidence.value.city }}</p>
      </div>
      <vcl-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        [label]="copyService.copies.client_data_update.personal.address.label"
        [msgErr]="copyService.copies.client_data_update.personal.address.error"
      >
        <input
          vclInput
          id="inputAddressResidence"
          type="text"
          [placeholder]="
            copyService.copies.client_data_update.personal.address.placeholder
          "
          formControlName="addressResidence"
          [value]="addressResidence"
        />
      </vcl-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.personal.address.label
        }}</label>
        <p>{{ formControls.addressResidence.value }}</p>
      </div>
      <voxel-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        id="livingPlaceLabel"
        [label]="
          copyService.copies.client_data_update.personal.living_place.label
        "
        [msgErr]="
          copyService.copies.client_data_update.personal.living_place.error
        "
      >
        <vcl-select
          id="livingPlace"
          [placeholder]="
            copyService.copies.client_data_update.personal.living_place
              .filter_placeholder
          "
          formControlName="livingPlace"
          [notFoundTitle]="
            copyService.copies.client_data_update.personal.living_place
              .filter_not_found_title
          "
          [notFoundMessage]="
            copyService.copies.client_data_update.personal.living_place
              .filter_not_found_message
          "
        >
          <vcl-select-option
            [id]="'livingPlace' + living.id"
            *ngFor="let living of living_option"
            [selected]="
              this.helperService.validateDiacritialMask(living.name) ===
              selectedLivingResidence
            "
            [value]="living"
          >
            {{ living.name }}
          </vcl-select-option>
        </vcl-select>
      </voxel-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.personal.living_place.label
        }}</label>
        <p>{{ formControls.livingPlace.value.name }}</p>
      </div>
      <voxel-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        id="stratumLabel"
        [label]="copyService.copies.client_data_update.personal.stratum.label"
        [msgErr]="copyService.copies.client_data_update.personal.stratum.error"
      >
        <vcl-select
          id="stratum"
          [placeholder]="
            copyService.copies.client_data_update.personal.stratum
              .filter_placeholder
          "
          formControlName="stratum"
          [notFoundTitle]="
            copyService.copies.client_data_update.personal.stratum
              .filter_not_found_title
          "
          [notFoundMessage]="
            copyService.copies.client_data_update.personal.stratum
              .filter_not_found_message
          "
        >
          <vcl-select-option
            [id]="'stratum' + stratum.id"
            *ngFor="let stratum of stratum_option"
            [selected]="stratum.name === selectedStratum.toString()"
            [value]="stratum"
          >
            {{ stratum.name }}
          </vcl-select-option>
        </vcl-select>
      </voxel-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.personal.stratum.label
        }}</label>
        <p>{{ formControls.stratum.value.name }}</p>
      </div>
      <voxel-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        id="civilStatusSelectionLabel"
        [label]="
          copyService.copies.client_data_update.personal.civil_status.label
        "
        [msgErr]="
          copyService.copies.client_data_update.personal.civil_status.error
        "
      >
        <vcl-select
          id="civilStatus"
          [placeholder]="
            copyService.copies.client_data_update.personal.civil_status
              .filter_placeholder
          "
          formControlName="civilStatus"
          [notFoundTitle]="
            copyService.copies.client_data_update.personal.civil_status
              .filter_not_found_title
          "
          [notFoundMessage]="
            copyService.copies.client_data_update.personal.civil_status
              .filter_not_found_message
          "
        >
          <vcl-select-option
            [id]="'civilStatusSelection' + civilStatus.id"
            *ngFor="let civilStatus of civil_status_options"
            [selected]="
              this.helperService.validateDiacritialMask(civilStatus.value) ===
              selectedCivilStatus
            "
            [value]="civilStatus"
          >
            {{ civilStatus.value }}
          </vcl-select-option>
        </vcl-select>
      </voxel-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.personal.civil_status.label
        }}</label>
        <p>{{ formControls.civilStatus.value.value }}</p>
      </div>
      <vcl-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        [label]="copyService.copies.client_data_update.personal.email.label"
        [msgErr]="copyService.copies.client_data_update.personal.email.error"
      >
        <input
          vclInput
          id="inputEmail"
          type="email"
          [disabled]="true"
          [placeholder]="
            copyService.copies.client_data_update.personal.email.placeholder
          "
          maxlength="100"
          formControlName="emailAddress"
          [value]="emailAddress"
        />
      </vcl-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.personal.email.label
        }}</label>
        <p>
          {{
            validationHelperService.maskMail(formControls.emailAddress.value)
          }}
        </p>
      </div>
      <vcl-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        [label]="copyService.copies.client_data_update.personal.phone.label"
        [msgErr]="copyService.copies.client_data_update.personal.phone.error"
      >
        <input
          vclInput
          id="inputPhone"
          maxlength="10"
          [disabled]="true"
          type="text"
          [placeholder]="
            copyService.copies.client_data_update.personal.phone.placeholder
          "
          formControlName="phoneContact"
          [value]="phoneContact"
        />
      </vcl-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.personal.phone.label
        }}</label>
        <p>
          {{
            validationHelperService.maskPhone(formControls.phoneContact.value)
          }}
        </p>
      </div>
      <div *ngIf="!confirmData" class="mt-4 mx-3 text_footer">
        <span
          *ngIf="this.channelCommunicatorService.getChannelId() !== chanelid"
          [innerHTML]="copyService.copies.client_data_update.personal.footer"
        ></span>
      </div>
    </div>
    <div class="mt-5 line-bottom"></div>
  </div>
  <!-- Laborales -->
  <div *ngIf="laboralData">
    <div class="mt-5 title_card">
      <span
        [innerHTML]="copyService.copies.client_data_update.laborales.title"
      ></span>
    </div>
    <div class="info-section">
      <voxel-form-field
      class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
      *ngIf="ciiu_show"
      id="ciiuLabelGeneral"
      [label]="copyService.copies.client_data_update.laborales.ciiu.label"
      [msgErr]="copyService.copies.client_data_update.laborales.ciiu.error"
    >
      <vcl-autocomplete
        id="ciiuGeneral"
        [placeholder]="
          copyService.copies.client_data_update.laborales.ciiu
            .filter_placeholder
        "
        (change)="selectOptionCiiu($event)"
        formControlName="ciiuGeneral"
        [notFoundTitle]="
          copyService.copies.client_data_update.laborales.ciiu
            .filter_not_found_title
        "
        [notFoundMessage]="
          copyService.copies.client_data_update.laborales.ciiu
            .filter_not_found_message
        "
      >
        <vcl-option
          [id]="ciiuGeneral"
          *ngFor="let option of optionsCiiu"
          [value]="option.ciiu"
        >
          {{ option.description }}
        </vcl-option>
      </vcl-autocomplete>
    </voxel-form-field>
      <voxel-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        *ngIf="ciiu_show && enableDetail"
        id="ciiuLabel"
        [label]="copyService.copies.client_data_update.laborales.ciiu.label"
        [msgErr]="copyService.copies.client_data_update.laborales.company.error"
      >
        <vcl-autocomplete
          id="ciiu"
          [placeholder]="
            copyService.copies.client_data_update.laborales.ciiu
              .filter_placeholder
          "
          (change)="reactiveCiiu($event)"
          formControlName="ciiu"
          [notFoundTitle]="
            copyService.copies.client_data_update.laborales.ciiu
              .filter_not_found_title
          "
          [notFoundMessage]="
            copyService.copies.client_data_update.laborales.ciiu
              .filter_not_found_message
          "
        >
          <vcl-option
            [id]="ciiu"
            *ngFor="let ciiu of ciiu_options"
            [value]="ciiu"
          >
            {{ ciiu.description }}
          </vcl-option>
        </vcl-autocomplete>
      </voxel-form-field>
      <div class="data-container" *ngIf="ciiu_show">
        <label>{{
          copyService.copies.client_data_update.laborales.ciiu.label
        }}</label>
        <p>{{ formControls.ciiu.value.description }}</p>
      </div>
      <vcl-form-field
        class="px-0 my-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        *ngIf="company_show"
        [label]="copyService.copies.client_data_update.laborales.company.label"
        [msgErr]="copyService.copies.client_data_update.laborales.company.error"
      >
        <input
          vclInput
          id="inputCompany"
          type="text"
          [placeholder]="
            copyService.copies.client_data_update.laborales.company.placeholder
          "
          formControlName="company"
        />
      </vcl-form-field>
      <div class="data-container" *ngIf="company_show">
        <label>{{
          copyService.copies.client_data_update.laborales.company.label
        }}</label>
        <p>{{ formControls.company.value }}</p>
      </div>
      <voxel-form-field
        class="px-0 my-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        *ngIf="contract_show"
        id="contractLabel"
        [label]="copyService.copies.client_data_update.laborales.contract.label"
        [msgErr]="copyService.copies.client_data_update.laborales.company.error"
      >
        <vcl-select
          id="contract"
          [placeholder]="
            copyService.copies.client_data_update.laborales.contract
              .filter_placeholder
          "
          formControlName="contract"
          [notFoundTitle]="
            copyService.copies.client_data_update.laborales.contract
              .filter_not_found_title
          "
          [notFoundMessage]="
            copyService.copies.client_data_update.laborales.contract
              .filter_not_found_message
          "
        >
          <vcl-select-option
            [id]="'contract' + contract.id"
            *ngFor="let contract of contract_option"
            [value]="contract"
            [selected]="
              contract.elementId == this.employedModel.typeContract.elementId
            "
          >
            {{ contract.label }}
          </vcl-select-option>
        </vcl-select>
      </voxel-form-field>
      <div class="data-container" *ngIf="contract_show">
        <label>{{
          copyService.copies.client_data_update.laborales.contract.label
        }}</label>
        <p>{{ formControls.contract.value.label }}</p>
      </div>
      <vcl-datepicker
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        (change)="reactiveDatePicker($event)"
        [required]="true"
        [(selectedDate)]="selectedDate"
        language="es"
        [minDate]="minimumDate"
        [maxDate]="maximumDate"
        dateLabel="{{
          copyService.copies.client_data_update.laborales.date_admission.label
        }}"
        invalidDateErrorMessage="{{
          copyService.copies.client_data_update.laborales.date_admission.error
        }}"
      ></vcl-datepicker>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.laborales.date_admission.label
        }}</label>
        <p>{{ date }}</p>
      </div>
      <voxel-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        [label]="
          copyService.copies.client_data_update.laborales.district_work.label
        "
        [msgErr]="
          copyService.copies.client_data_update.laborales.district_work.error
        "
      >
        <vcl-autocomplete
          [placeholder]="
            copyService.copies.client_data_update.laborales.district_work
              .filter_placeholder
          "
          [notFoundTitle]="
            copyService.copies.client_data_update.laborales.district_work
              .filter_not_found_title
          "
          [notFoundMessage]="
            copyService.copies.client_data_update.laborales.district_work
              .filter_not_found_message
          "
          formControlName="districtWorkValue"
          (change)="districtSelect($event, 'laboral')"
        >
          <vcl-option
            [selected]="
              selecteCityWork[0]
                ? selecteCityWork[0].description.indexOf(
                    districtOption.district
                      .toUpperCase()
                      .replace('Á', 'A')
                      .replace('É', 'E')
                      .replace('Í', 'I')
                      .replace('Ó', 'O')
                      .replace('Ú', 'U')
                  ) > -1
                : null
            "
            *ngFor="let districtOption of district_option"
            [value]="districtOption"
          >
            {{ districtOption.district }}
          </vcl-option>
        </vcl-autocomplete>
      </voxel-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.laborales.district_work.label
        }}</label>
        <p>{{ formControls.districtWorkValue.value.district }}</p>
      </div>
      <voxel-form-field
        *ngIf="!isDisabledCityWork; else isDisabledCityWorkForm"
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        id="cityWorkingLabel"
        [label]="
          copyService.copies.client_data_update.laborales.city_work.label
        "
        [msgErr]="
          copyService.copies.client_data_update.laborales.city_work.error
        "
      >
        <vcl-autocomplete
          id="cityWorking"
          [placeholder]="
            copyService.copies.client_data_update.laborales.city_work
              .filter_placeholder
          "
          formControlName="cityWorking"
          [notFoundTitle]="
            copyService.copies.client_data_update.laborales.city_work
              .filter_not_found_title
          "
          [notFoundMessage]="
            copyService.copies.client_data_update.laborales.city_work
              .filter_not_found_message
          "
        >
          <vcl-option
            [id]="'cityWorking' + cityWork.id"
            *ngFor="let cityWork of city_option_work"
            [selected]="
              selecteCityWork[0]
                ? selecteCityWork[0].description.indexOf(
                    cityWork.city
                      .toUpperCase()
                      .replace('Á', 'A')
                      .replace('É', 'E')
                      .replace('Í', 'I')
                      .replace('Ó', 'O')
                      .replace('Ú', 'U')
                  ) > -1
                : null
            "
            [value]="cityWork"
          >
            {{ cityWork.city }}
          </vcl-option>
        </vcl-autocomplete>
      </voxel-form-field>
      <ng-template #isDisabledCityWorkForm>
        <voxel-form-field
          class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
          *ngIf="city_work_show"
          id="cityWorkingLabel"
          [label]="
            copyService.copies.client_data_update.laborales.city_work.label
          "
          [msgErr]="
            copyService.copies.client_data_update.laborales.city_work.error
          "
        >
          <vcl-autocomplete
            id="cityWorking"
            [placeholder]="
              copyService.copies.client_data_update.laborales.city_work
                .filter_placeholder
            "
            formControlName="cityWorking"
            [notFoundTitle]="
              copyService.copies.client_data_update.laborales.city_work
                .filter_not_found_title
            "
            [notFoundMessage]="
              copyService.copies.client_data_update.laborales.city_work
                .filter_not_found_message
            "
          >
          </vcl-autocomplete>
        </voxel-form-field>
      </ng-template>
      <div class="data-container" *ngIf="city_work_show">
        <label>{{
          copyService.copies.client_data_update.laborales.city_work.label
        }}</label>
        <p>{{ formControls.cityWorking.value.city }}</p>
      </div>
      <vcl-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        *ngIf="address_work_show"
        [label]="
          copyService.copies.client_data_update.laborales.address_company.label
        "
        [msgErr]="
          copyService.copies.client_data_update.laborales.address_company.error
        "
      >
        <input
          vclInput
          id="inputAddressCompany"
          type="text"
          [placeholder]="
            copyService.copies.client_data_update.laborales.address_company
              .placeholder
          "
          formControlName="addressWork"
        />
      </vcl-form-field>
      <div class="data-container" *ngIf="address_work_show">
        <label>{{
          copyService.copies.client_data_update.laborales.address_company.label
        }}</label>
        <p>{{ formControls.addressWork.value }}</p>
      </div>
      <vcl-form-field
        class="px-0 mt-4 col-4 col-sm-4 col-pr-12 col-md-4 col-xl-4 col-lg-4"
        *ngIf="phone_work_show"
        [label]="
          copyService.copies.client_data_update.laborales.phone_company.label
        "
        [msgErr]="
          copyService.copies.client_data_update.laborales.phone_company.error
        "
      >
        <input
          vclInput
          id="inputPhoneCompany"
          minlength="7"
          maxlength="10"
          (input)="reactiveInputChangePhoneWork()"
          (focus)="inputPhone($event)"
          (focusout)="outPhone($event)"
          type="text"
          [placeholder]="
            copyService.copies.client_data_update.laborales.phone_company
              .placeholder
          "
          formControlName="phoneCompany"
        />
      </vcl-form-field>
      <div class="data-container" *ngIf="phone_work_show">
        <label>{{
          copyService.copies.client_data_update.laborales.phone_company.label
        }}</label>
        <p>{{ formControls.phoneCompany.value }}</p>
      </div>
    </div>
    <div class="mt-5 line-bottom"></div>
  </div>
  <!-- Financieros -->
  <div *ngIf="financialData" class="mb-5">
    <div class="mt-5 title_card">
      <span
        [innerHTML]="copyService.copies.client_data_update.financial.title"
      ></span>
    </div>
    <div class="info-section">
      <vcl-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        [label]="copyService.copies.client_data_update.financial.income.label"
        [msgErr]="copyService.copies.client_data_update.financial.income.error"
      >
        <input
          vclInput
          voxelMask="currency"
          [config]="config"
          [placeholder]="
            copyService.copies.client_data_update.financial.income.placeholder
          "
          formControlName="income"
          [value]="income"
        />
      </vcl-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.financial.income.label
        }}</label>
        <p>${{ formControls.income.value | number }}</p>
      </div>
      <voxel-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        [label]="copyService.copies.client_data_update.financial.origin.label"
        [msgErr]="copyService.copies.client_data_update.financial.origin.error"
      >
        <vcl-select
          id="originFunds"
          [placeholder]="
            copyService.copies.client_data_update.financial.origin
              .filter_placeholder
          "
          formControlName="origin"
          [notFoundTitle]="
            copyService.copies.client_data_update.financial.origin
              .filter_not_found_title
          "
          [notFoundMessage]="
            copyService.copies.client_data_update.financial.origin
              .filter_not_found_message
          "
        >
          <vcl-select-option
            [id]="'originFunds' + originFunds.id"
            *ngFor="let originFunds of origin_options"
            [selected]="originFunds.value === selectOriginIncome"
            [value]="originFunds"
          >
            {{ originFunds.value }}
          </vcl-select-option>
        </vcl-select>
      </voxel-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.financial.origin.label
        }}</label>
        <p>{{ formControls.origin.value.value }}</p>
      </div>
      <div
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4 hide-on-confirm"
      >
        <h3
          class="aux_title"
          [innerHTML]="
            copyService.copies.client_data_update.financial.other_income.label
          "
        ></h3>
        <voxel-radio-button-group>
          <voxel-radio-button
            *ngFor="let selectionList of radioIncome"
            [id]="'radioButtonID' + selectionList.label"
            radioName="dec"
            (change)="isSelectIncome($event)"
            [checked]="selectionList.checked"
            [value]="selectionList.value"
            >{{ selectionList.label }}</voxel-radio-button
          >
        </voxel-radio-button-group>
      </div>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.financial.other_income.label
        }}</label>
        <p>{{ showOtherIncomes ? 'Si' : 'No' }}</p>
      </div>
      <div *ngIf="showOtherIncomes" class="col-12 px-0 mx-auto">
        <voxel-form-field
          class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
          [label]="
            copyService.copies.client_data_update.financial.origin_other_income
              .label
          "
          [msgErr]="
            copyService.copies.client_data_update.financial.origin_other_income
              .error
          "
        >
          <vcl-select
            id="originOtherIncome"
            (change)="reactiveOtherIncomes()"
            [placeholder]="
              copyService.copies.client_data_update.financial
                .origin_other_income.filter_placeholder
            "
            formControlName="originOtherIncome"
            [notFoundTitle]="
              copyService.copies.client_data_update.financial
                .origin_other_income.filter_not_found_title
            "
            [notFoundMessage]="
              copyService.copies.client_data_update.financial
                .origin_other_income.filter_not_found_message
            "
          >
            <vcl-select-option
              [id]="'originOtherIncome' + origin_other_income.id"
              *ngFor="let origin_other_income of origin_options"
              [selected]="
                origin_other_income.value.toLowerCase() ===
                selectOtherOriginIncome.toLowerCase()
              "
              [value]="origin_other_income"
            >
              {{ origin_other_income.value }}
            </vcl-select-option>
          </vcl-select>
        </voxel-form-field>
        <div class="data-container px-0 col-12">
          <label>{{
            copyService.copies.client_data_update.financial.origin_other_income
              .label
          }}</label>
          <p>{{ this.formControls.originOtherIncome.value.value }}</p>
        </div>
        <vcl-form-field
          class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
          [label]="
            copyService.copies.client_data_update.financial.value_other_income
              .label
          "
          [msgErr]="
            copyService.copies.client_data_update.financial.value_other_income
              .error
          "
        >
          <input
            vclInput
            voxelMask="currency"
            (input)="reactiveOtherIncomes()"
            [config]="config"
            [placeholder]="
              copyService.copies.client_data_update.financial.value_other_income
                .placeholder
            "
            formControlName="OtherIncomes"
            [value]="valueOtherIncomes"
          />
        </vcl-form-field>
        <div class="data-container px-0 col-12">
          <label>{{
            copyService.copies.client_data_update.financial.value_other_income
              .label
          }}</label>
          <p>${{ this.formControls.OtherIncomes.value | number }}</p>
        </div>
      </div>
      <vcl-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        [label]="copyService.copies.client_data_update.financial.expenses.label"
        [msgErr]="
          copyService.copies.client_data_update.financial.expenses.error
        "
      >
        <input
          vclInput
          voxelMask="currency"
          [config]="config"
          [placeholder]="
            copyService.copies.client_data_update.financial.expenses.placeholder
          "
          formControlName="Expenses"
          [value]="valueExpenses"
        />
      </vcl-form-field>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.financial.expenses.label
        }}</label>
        <p>${{ formControls.Expenses.value | number }}</p>
      </div>
      <vcl-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        [label]="copyService.copies.client_data_update.financial.debts.label"
        [msgErr]="copyService.copies.client_data_update.financial.debts.error"
      >
        <input
          vclInput
          voxelMask="currency"
          [config]="config"
          [placeholder]="
            copyService.copies.client_data_update.financial.debts.placeholder
          "
          formControlName="Debts"
          [value]="valueDebts"
        />
      </vcl-form-field>
      <span class="info hide-on-confirm">{{
        copyService.copies.client_data_update.financial.debts.sub
      }}</span>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.financial.debts.label
        }}</label>
        <p>${{ formControls.Debts.value | number }}</p>
      </div>
      <vcl-form-field
        class="px-0 mt-4 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4"
        [label]="copyService.copies.client_data_update.financial.goods.label"
        [msgErr]="copyService.copies.client_data_update.financial.goods.error"
      >
        <input
          vclInput
          voxelMask="currency"
          [config]="config"
          [placeholder]="
            copyService.copies.client_data_update.financial.goods.placeholder
          "
          formControlName="Goods"
          [value]="valueGoods"
        />
      </vcl-form-field>
      <span class="info hide-on-confirm">{{
        copyService.copies.client_data_update.financial.goods.sub
      }}</span>
      <div class="data-container">
        <label>{{
          copyService.copies.client_data_update.financial.goods.label
        }}</label>
        <p>${{ formControls.Goods.value | number }}</p>
      </div>
    </div>
  </div>
</form>
<app-controls
  class="mt-5"
  id="clientDataUpdateButton"
  [hasPrevious]="true"
  [nextLabel]="copyService.copies.client_data_update.button"
  [nextDisabled]="!formGroup.valid || !date_button || !other_btn_show"
  [previousLabel]="backLabel"
  (next)="next()"
  (previous)="back()"
></app-controls>
